
import { format } from 'date-fns'
import PrismicSlice from './PrismicSlice.vue'
import Carousel from './Carousel.vue'
import ArticleCard from './ArticleCard.vue'

export default {
  name: 'NewsAndGuidesArticle',

  components: { PrismicSlice, Carousel, ArticleCard },
  props: {
    document: {
      type: Object,
      required: true,
    },
    similarArticles: {
      type: Array,
      default: () => [],
    },
    prevArticle: {
      type: Object,
      default: null,
    },
    nextArticle: {
      type: Object,
      default: null,
    },
  },

  computed: {
    refLabel() {
      return 'similar'
    },
    date() {
      if (this.document.data.publish_date_override)
        return format(new Date(this.document.data.publish_date_override), 'PP')
      return format(new Date(this.document.last_publication_date), 'PP')
    },

    fullUrl() {
      return this.encodeURI(`https://www.nurole.com${this.document.url}`)
    },

    title() {
      return this.encodeURI(this.document.data.title)
    },

    shareFacebook() {
      const imageUrl = this.encodeURI(this.document.data.featured_image.url)
      const summary = this.encodeURI(this.document.data.subtitle || '')
      return `http://www.facebook.com/sharer/sharer.php?u=${this.fullUrl}&picture=${imageUrl}&title=${this.title}&description=${summary}&caption=Nurole`
    },

    shareTwitter() {
      return `https://twitter.com/intent/tweet?url=${this.fullUrl}&via=NuroleCom&text=${this.title}`
    },

    shareLinkedin() {
      const imageUrl = this.encodeURI(this.document.data.featured_image.url)
      const title = this.encodeURI(this.document.data.title.slice(0, 200))
      const summary = this.encodeURI(
        this.document.data.subtitle?.slice(0, 256) || ''
      )

      return `https://www.linkedin.com/shareArticle?url=${this.fullUrl}&image_url=https:${imageUrl}&mini=true&title=${title}&summary=${summary}&source=Nurole`
    },

    shareEmail() {
      const title = this.encodeURI(this.title)
      return `mailto:?body=${this.fullUrl}&subject=${title}`
    },
  },

  methods: {
    encodeURI(url) {
      return encodeURIComponent(url)
    },

    sharePrint() {
      if (window.print) window.print()
    },
  },
}
